import { render, staticRenderFns } from "./HistoriesTab.vue?vue&type=template&id=3263288d&scoped=true&lang=pug"
import script from "./HistoriesTab.vue?vue&type=script&lang=ts"
export * from "./HistoriesTab.vue?vue&type=script&lang=ts"
import style0 from "./HistoriesTab.vue?vue&type=style&index=0&id=3263288d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3263288d",
  null
  
)

export default component.exports